import "../App.css";
import cloud1 from "../images/cloud1.svg";
import stars1 from "../images/stars1.svg";
import sheepCloud from "../images/Sheep-Cloud.png";
import pillow from "../images/pillow.png";
import moon1 from "../images/moon 1.png";
import moon2 from "../images/moon 2.png";
import moon3 from "../images/moon 3.png";
import moon4 from "../images/moon 4.png";
import moon5 from "../images/moon 5.png";
import moon6 from "../images/moon 6.png";
import moon7 from "../images/moon 7.png";

import { forwardRef } from "react";

function Tracks(props, ref) {
  return (
    <>
      <div
        ref={ref}
        class="tracks position-relative text-white text-center w-100 display-block"
        style={{
          overflow: "hidden",
        }}
      >
        <div class="content pb-5" style={{ top: "3vw" }}>
          <h1 style={{ fontSize: "4vw", fontWeight: "bold" }}>TRACKS</h1>

          <div className="tracks-container container" style={{ width: "100%" }}>
            <div className="row">
              <div className="col-md-3 mt-md-4">
                <div id="track1">
                  <img
                    src={moon1}
                    alt="Stars"
                    className="img-fluid cursor-pointer"
                    style={{
                      maxWidth: "7vw",
                    }}
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTrack1"
                  />
                  <h6 style={{ marginLeft: "1rem" }}>Best Beginner Hack</h6>
                  <p style={{ marginLeft: "1rem" }}>First Sleepover</p>
                  <div class="collapse" id="collapseTrack1">
                    <div class="card card-body text-black">
                      This track is perfect for those who are new to the world
                      of hackathons. Just like your first sleepover, it's all
                      about making new friends, learning new things, and having
                      a blast while you dive into the exciting world of coding
                      and innovation. Come join the "First Sleepover" and
                      experience the magic of your first hackathon!
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-3 mt-md-4">
                <div id="track2">
                  <img
                    src={moon2}
                    alt="Stars"
                    className="img-fluid cursor-pointer"
                    style={{
                      maxWidth: "7vw",
                    }}
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTrack2"
                  />
                  <h6 style={{ marginLeft: "1rem" }}>
                    Best Diversity and Inclusion Hack
                  </h6>
                  <p style={{ marginLeft: "1rem" }}>
                    Inclusion Under One Blanket
                  </p>
                  <div class="collapse" id="collapseTrack2">
                    <div class="card card-body text-black">
                      Embrace the spirit of inclusivity and diversity in tech!
                      In this track, we challenge you to create solutions that
                      promote inclusivity, break down barriers, and foster a
                      sense of belonging. Just like friends from all backgrounds
                      coming together under one blanket at a slumber party,
                      "Inclusion Under One Blanket" encourages you to build
                      solutions that unite and empower.
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-3 mt-md-4">
                <div id="track3">
                  <img
                    src={moon3}
                    alt="Stars"
                    className="img-fluid cursor-pointer"
                    style={{
                      maxWidth: "7vw",
                    }}
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTrack3"
                  />
                  <h6 style={{ marginLeft: "1rem" }}>Best Creativity Hack</h6>
                  <p style={{ marginLeft: "1rem" }}>Dreamy Ideas Unleashed</p>
                  <div class="collapse" id="collapseTrack3">
                    <div class="card card-body text-black">
                      Unleash your inner creativity in this hackathon track!
                      Just like the imaginative dreams that flow during a
                      slumber party, "Dreamy Ideas Unleashed" invites you to
                      push the boundaries of innovation and design. Let your
                      creative ideas run wild and bring them to life through
                      your projects.
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-3 mt-md-4">
                <div id="track4">
                  <img
                    src={moon4}
                    alt="Stars"
                    className="img-fluid cursor-pointer"
                    style={{
                      maxWidth: "7vw",
                    }}
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTrack4"
                  />
                  <h6 style={{ marginLeft: "1rem" }}>
                    Best AI/ML Immersion Hack
                  </h6>
                  <p style={{ marginLeft: "1rem" }}>
                    Machine Learning Pajama Party
                  </p>
                  <div class="collapse" id="collapseTrack4">
                    <div class="card card-body text-black">
                      Join the "Machine Learning Pajama Party" to immerse
                      yourself in the world of Artificial Intelligence and
                      Machine Learning. Similar to a fun-filled pajama party
                      with friends, this track encourages you to explore data,
                      algorithms, and the endless possibilities of AI/ML, all
                      while wearing your comfiest pajamas!
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 mt-md-4">
                <div id="track5">
                  <img
                    src={moon5}
                    alt="Stars"
                    className="img-fluid cursor-pointer"
                    style={{
                      maxWidth: "7vw",
                    }}
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTrack5"
                  />
                  <h6 style={{ marginLeft: "1rem" }}>
                    Best Sustainability Hack
                  </h6>
                  <p style={{ marginLeft: "1rem" }}>Green Dreams Innovation</p>
                  <div class="collapse" id="collapseTrack5">
                    <div class="card card-body text-black">
                      Embrace the dream of a greener and more sustainable future
                      in this track. Just as a slumber party can be filled with
                      dreams and aspirations, "Green Dreams Innovation"
                      challenges you to create solutions that address
                      environmental challenges, reduce carbon footprints, and
                      promote sustainable living.
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3 mt-md-4">
                <div id="track6">
                  <img
                    src={moon6}
                    alt="Stars"
                    className="img-fluid cursor-pointer"
                    style={{
                      maxWidth: "7vw",
                    }}
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTrack6"
                  />
                  <h6 style={{ marginLeft: "1rem" }}>Best Health Hack</h6>
                  <p style={{ marginLeft: "1rem" }}>Wellness Slumber Party</p>
                  <div class="collapse" id="collapseTrack6">
                    <div class="card card-body text-black">
                      Get ready for a "Wellness Slumber Party" where health and
                      well-being take center stage. Similar to a night dedicated
                      to self-care with friends, this track encourages you to
                      develop innovative solutions that improve mental and
                      physical health, promote well-being, and help individuals
                      lead healthier lives.
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-3 mt-md-4">
                <div id="track7">
                  <img
                    src={moon7}
                    alt="Stars"
                    className="img-fluid cursor-pointer"
                    style={{
                      maxWidth: "7vw",
                    }}
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTrack7"
                  />
                  <h6 style={{ marginLeft: "1rem" }}>Best Hardware Hack</h6>
                  <p style={{ marginLeft: "1rem" }}>SlumberTech Creations</p>
                  <div class="collapse" id="collapseTrack7">
                    <div class="card card-body text-black">
                      Bring the magic of a slumber party to the world of
                      hardware hacking. This category seeks imaginative and
                      whimsical hardware solutions that seamlessly blend
                      technology with the coziness of a night in with friends.
                      Build devices that make everyday tasks feel like a slumber
                      party surprise, promoting joy, comfort, and a touch of
                      enchantment in our daily lives.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="clouds">
          <img
            src={cloud1}
            alt="Cloud Image"
            className="position-absolute img-fluid cloud-animation-4"
            style={{
              maxWidth: "15%",
              top: 200,
              right: 0,
              zIndex: -1,
              opacity: 0.1,
            }}
          />
          <img
            src={cloud1}
            alt="Cloud Image"
            className="position-absolute img-fluid"
            style={{
              maxWidth: "15%",
              top: 400,
              right: 0,
              zIndex: -1,
            }}
          />
          <img
            src={cloud1}
            alt="Cloud Image"
            className="position-absolute img-fluid"
            style={{
              maxWidth: "15%",
              top: 20,
              left: "5%",
              zIndex: -1,
            }}
          />

          <img
            src={sheepCloud}
            alt="Cloud Image"
            className="position-absolute img-fluid"
            style={{
              maxWidth: "15%",
              top: "55%",
              left: -35,
              zIndex: -1,
            }}
          />
        </div>
        <div className="stars">
          <img
            src={stars1}
            alt="Stars"
            className="position-absolute img-fluid"
            style={{
              maxWidth: "99%",
              left: 0,
              top: 100,
              zIndex: -1,
              pointerEvents: "none",
            }}
          />

          <div className="position-absolute" style={{ top: 0 }}>
            <div className="stars-1"></div>
            <div className="stars-2"></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default forwardRef(Tracks);
